import React from 'react';
import { motion } from 'framer-motion';
export function Urgency() {
  return <section className="bg-[#FAFAF8] py-20 md:py-28" data-id="element-465">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto px-6" data-id="element-466">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] tracking-tight mb-10 leading-tight" data-id="element-467">
          The Window Is Real. And It Narrows.
        </h2>

        <div className="space-y-6 text-lg text-[#4B5563] leading-relaxed" data-id="element-468">
          <p data-id="element-469">
            <strong className="text-[#1A1A1A]" data-id="element-470">
              Dormant follicles can be reactivated. Dead follicles cannot.
            </strong>
          </p>
          <p data-id="element-471">
            The line between those two states moves. With every month of
            continued energy deprivation, more follicles progress toward a state
            where reactivation becomes less likely. The men who get the best
            results from this protocol are consistently the men who intervened
            early to moderate loss — before the majority of follicles crossed
            that threshold.
          </p>
        </div>

        {/* Pull Quote */}
        <div className="border-l-4 border-[#C8A04A] pl-6 my-12" data-id="element-472">
          <p className="text-xl md:text-2xl italic text-[#1A1A1A] leading-relaxed" data-id="element-473">
            "I wish I started earlier."
          </p>
        </div>

        <div className="space-y-6 text-lg text-[#4B5563] leading-relaxed" data-id="element-474">
          <p data-id="element-475">
            That sentence appears more than any other in hair loss forums. Not
            because these men weren't smart. Because they made the same
            calculation you might be making right now: "I'll wait and see."
          </p>
          <p data-id="element-476">
            Waiting has a cost. Every month narrows the window.{' '}
            <strong className="text-[#1A1A1A]" data-id="element-477">
              There is no version of this where delay is the smart play.
            </strong>
          </p>
        </div>

        {/* Optional density graph placeholder */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mt-14 bg-white border border-gray-200 rounded-lg p-8" data-id="element-478">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#9CA3AF] mb-6" data-id="element-479">
            Hair Density Over Time
          </p>
          <div className="relative h-48" data-id="element-480">
            {/* Y-axis label */}
            <div className="absolute left-0 top-0 bottom-8 flex flex-col justify-between text-xs text-[#9CA3AF]" data-id="element-481">
              <span data-id="element-482">High</span>
              <span data-id="element-483">Low</span>
            </div>
            {/* Graph area */}
            <div className="ml-10 h-full relative" data-id="element-484">
              {/* No action line */}
              <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 160" preserveAspectRatio="none" data-id="element-485">
                <path d="M 0 20 Q 100 30 200 70 T 400 140" fill="none" stroke="#DC2626" strokeWidth="2" strokeDasharray="6 4" opacity="0.5" data-id="element-486" />
                <path d="M 0 20 Q 100 25 150 35 Q 200 30 250 25 T 400 20" fill="none" stroke="#C8A04A" strokeWidth="2.5" data-id="element-487" />
              </svg>
              {/* Labels */}
              <div className="absolute bottom-[-24px] left-0 text-xs text-[#9CA3AF]" data-id="element-488">
                Today
              </div>
              <div className="absolute bottom-[-24px] right-0 text-xs text-[#9CA3AF]" data-id="element-489">
                12 months
              </div>
              <div className="absolute top-2 right-4 flex flex-col gap-2" data-id="element-490">
                <div className="flex items-center gap-2" data-id="element-491">
                  <div className="w-4 h-0.5 bg-[#C8A04A]" data-id="element-492" />
                  <span className="text-xs text-[#C8A04A] font-medium" data-id="element-493">
                    CrownControl™
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-494">
                  <div className="w-4 h-0.5 bg-red-500 opacity-50" style={{
                  borderTop: '2px dashed'
                }} data-id="element-495" />
                  <span className="text-xs text-[#9CA3AF]" data-id="element-496">No action</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </section>;
}